<template>
  <el-dialog class="rc-dialog" :title="msgTitle" :visible.sync="addDialog.flag" width="45%" append-to-body	
    :close-on-click-modal="false" :close-on-press-escape="false" destroy-on-close>
    <el-form class="form" size="small" label-position="right" label-width="140px" :rules="rules" :model="trainForm"
      ref="trainForm">
      <el-row>
        <el-col :span="24">
          <el-form-item label="课程面向分组：" prop="groupType">
            <el-radio-group v-model="trainForm.groupType">
              <el-radio :label="1">全部学员</el-radio>
              <el-radio :label="2">指定分组</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="trainForm.groupType == 2">
          <el-form-item label="" prop="groupIdList">
            <wySelect v-model="trainForm.groupIdList" :appendToBody="false" placeholder="请选择面向分组" :options="groupList" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="日期：" prop="teachingDate">
            <el-date-picker v-model="trainForm.teachingDate" type="date" value-format="yyyy-MM-dd" placeholder="请选择日期"
              :disabled="!!addDialog.editId" :append-to-body="false">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="开始时间：" prop="startTime">
            <el-time-picker v-model="trainForm.startTime" placeholder="请选择开始时间" value-format="HH:mm" format="HH:mm"
              :disabled="!!addDialog.editId" :append-to-body="false">
            </el-time-picker>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="结束时间：" prop="endTime">
            <el-time-picker v-model="trainForm.endTime" placeholder="请选择结束时间" value-format="HH:mm" format="HH:mm"
              :disabled="!!addDialog.editId" :append-to-body="false">
            </el-time-picker>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="内容：" prop="courseName">
            <el-input type="textarea" rows="4" v-model="trainForm.courseName" placeholder="请输入日程内容"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="教学形式：" prop="teachingForm">
            <el-select v-model="trainForm.teachingForm" placeholder="请选择教学形式" style="width:100%">
              <el-option v-for="item in teachingFormData" :key="item.paramKey" :label="item.paramValue"
                :value="item.paramValue"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="主持人：" prop="teacherName">
            <el-input v-model="trainForm.teacherName" placeholder="请输入主持人"></el-input>
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item label="主持人单位及职务：" prop="unitPosition">
            <el-input v-model="trainForm.unitPosition" placeholder="请输入主持人单位及职务"></el-input>
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item label="上课地点：" prop="roomType">
            <el-radio-group v-model="trainForm.roomType" @input="changeRoomType">
              <el-radio v-for="item in roomTypes" :key="item.paramKey" :label="Number(item.paramKey)">{{ item.paramValue
                }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="trainForm.roomType == 1">
          <el-form-item label="" prop="roomId">
            <load-select class="form-select" v-model="trainForm.roomId" dictLabel="teachingLocation" dictValue="uuid"
              :data="data" :page="page" :hasMore="more" :request="getData" @change="setChange"
              :defaultVal="trainForm.teachingLocation" placeholder="请选择地点（输入地点关键字以查询）" :isInit="isSetInit"
              :isAllowCreate="true" @ChangeValue="changeValue" :appendToBody="false" />
          </el-form-item>
        </el-col>
        <el-col :span="24" v-else>
          <el-form-item label="" prop="roomId">
            <load-select class="form-select" v-model="trainForm.roomId" dictLabel="roomGroupName" dictValue="uuid"
              :data="roomGroupList" :page="roomPage" :hasMore="roomGroupMore" :request="getRoomGroupData"
              @change="setChangeRoom" :defaultVal="trainForm.teachingLocation" placeholder="请选择自习室组（点击页面左上角“自习室管理”设置）"
              :isInit="isSetInitRoom" @ChangeValue="changeRoomGroup" :appendToBody="false"/>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="课件：" prop="attachmentList">
            <upload ref="upload" :limit="1" :accepts="acceptsType" :path="'class/attachment'"
              v-model="trainForm.attachmentList" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cancel" size="small">取 消</el-button>
      <el-button type="primary" @click="submit" size="small">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { classRoomPage, getCourseClassInfo, saveCourseClass, updateCourseClass, classRoomGroupPage } from "@/api/class";
import { groupNames } from "@/api/groupManage";
import { getSysParamByTypes } from "@/api/sysParam";
import LoadSelect from "@/components/load-select/index.vue";
import Upload from "@/components/upload/index";
import rulesFactory from "@/utils/rules";
import wySelect from "@/components/wySelect/index"
export default {
  components: {
    Upload,
    LoadSelect,
    wySelect
  },
  props: {
    classId: {
      type: String,
      default: () => null
    },
    addDialog: {
      type: Object,
      default: () => {
        return {
          flag: false,
          editId: null
        };
      },
    }
  },
  data() {
    return {
      groupList: [],
      roomGroupList: [],
      roomGroupMore: false,
      roomPage: 1,
      isSetInitRoom: true,
      more: true,
      page: 1,
      data: [],
      isSetInit: true,
      rulesFactory,
      msgTitle: "新增日程安排",
      acceptsType: ['pdf'],
      trainForm: {
        groupType: 1,
        groupIdList: [],
        classId: "",
        attachmentList: [],
        startTime: "",
        endTime: "",
        courseName: "",
        teachingForm: "",
        teacherName: "",
        unitPosition: "",
        teachingLocation: "",
        roomId: "",
        roomType: 1,
      },
      teachingFormData: [],
      roomTypes: [],
      rules: {
        groupType: [{ required: true, message: "请选择课程面向分组类型" }],
        groupIdList: [{ required: true, message: "请选择指定分组" }],
        teachingDate: [{ required: true, message: "请选择日期" }],
        startTime: [{ required: true, message: "请选择开始时间" }],
        endTime: [{ required: true, message: "请选择结束时间" }],
        courseName: [rulesFactory.required("请输入日程内容"), rulesFactory.size("最多输入500个字", 0, 500)],
        teachingForm: [{ required: true, message: "请选择教学形式" }],
        teacherName: [rulesFactory.size("最多输入30个字", 0, 30)],
        unitPosition: [rulesFactory.size("最多输入255个字", 0, 255)],
        roomId: [rulesFactory.required("内容不能为空"), rulesFactory.size("最多输入255个字", 0, 255)],
        roomType: [{ required: true, message: "请选择地点类型" }],
      },
    };
  },
  created() {
    this.getGrounpList()
    if (this.addDialog.editId) {
      this.msgTitle = "编辑日程安排";
      this.getCourseClassInfo();
    }
    this.getSysParamByTypes(["TEACHING_FORM_TYPE", "ROOM_TYPE"]);

  },
  methods: {
    getGrounpList() {
      groupNames({ classId: this.classId, excludeNoGroup: 1 }).then((res) => {
        if (res.code == 0) {
          this.groupList = res.data;
          // 容错处理
          if (this.trainForm.groupIdList && this.trainForm.groupIdList.length) {
            let list = this.groupList.filter(item => this.trainForm.groupIdList.includes(item.paramKey));
            this.trainForm.groupIdList = list.map(item => item.paramKey);
          }
        }
      });
    },
    cancel() {
      this.$emit("closeAddDialog");
    },
    // 获取日程安排详情
    getCourseClassInfo() {
      getCourseClassInfo(this.addDialog.editId).then(({ code, data }) => {
        if (code === 0) {
          let res = Object.assign({}, data);
          if (res.attachment) {
            res.attachmentList = JSON.parse(res.attachment);
          } else {
            res.attachmentList = [];
          }
          // 容错处理
          if (this.groupList && this.groupList.length) {
            let list = this.groupList.filter(item => res.groupIdList.includes(item.paramKey));
            res.groupIdList = list.map(item => item.paramKey);
          }
          this.trainForm = res;
        }
      });
    },
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({ types: types }).then((res) => {
        if (!res || res.code != 0) return;
        this.teachingFormData = res.data["TEACHING_FORM_TYPE"];
        this.roomTypes = res.data["ROOM_TYPE"];
      });
    },
    // 下拉加载自习室组
    getRoomGroupData({ keyword = "" } = {}) {
      return new Promise((resolve) => {
        classRoomGroupPage({ classId: this.classId, teachingLocation: keyword }).then(({ code, data }) => {
          if (code !== 0) return;
          this.roomGroupList = data;
          resolve();
        });
      });
    },
    // 下拉加载地点
    getData({ page = 1, more = false, keyword = "" } = {}) {
      return new Promise((resolve) => {
        classRoomPage({ page, teachingLocation: keyword }).then(({ code, data }) => {
          if (code !== 0) return;
          if (more) {
            this.data = [...this.data, ...data.records];
          } else {
            this.data = data.records;
          }
          this.page = data.current;
          let { current, total, size } = data;
          this.more = current * size < total;
          this.page = current;
          resolve();
        });
      });
    },
    // 下拉加载
    setChange() {
      // this.isSetInit = false;
    },
    // 下拉加载自习室组
    setChangeRoom() {
      this.isSetInitRoom = false;
    },
    changeRoomType(val) {
      this.trainForm.teachingLocation = "";
      this.trainForm.roomId = ""
    },
    changeValue(val) {
      let flag = val.match(/^[ ]*$/);
      if (!flag) {
        let item = this.data.filter((item) => item.uuid == val)[0];
        if (!item) {
          this.trainForm.teachingLocation = val;
        } else {
          this.trainForm.teachingLocation = item.teachingLocation;
        }
      } else {
        this.trainForm.teachingLocation = "";
        this.trainForm.roomId = "";
      }
    },
    selectChange(val) {
      this.trainForm.groupIdList = val;
    },
    changeRoomGroup(val) {
      if (!!val) {
        let item = this.roomGroupList.filter((item) => item.uuid == val)[0];
        if (!item) {
          this.trainForm.teachingLocation = val;
        } else {
          this.trainForm.teachingLocation = item.roomGroupName;
        }
      } else {
        this.trainForm.teachingLocation = ""
      }
    },
    // 保存
    submit() {
      this.$refs["trainForm"].validate().then(() => {
        let params = {
          ...this.trainForm,
          classId: this.classId
        };
        if (this.trainForm.roomId == this.trainForm.teachingLocation) {
          delete params.roomId;
        }
        if (this.trainForm.attachmentList.length > 0) {
          params["attachment"] = JSON.stringify(this.trainForm.attachmentList);
        } else {
          params["attachment"] = null;
        }
        if (this.addDialog.editId) {
          updateCourseClass(params).then((res) => {
            if (!res || res.code != 0) return;
            this.$message({
              message: res.msg,
              type: "success",
            });
            this.$parent.getScheduleList();
            this.$emit("closeAddDialog");
          })
        } else {
          saveCourseClass(params).then((res) => {
            if (!res || res.code != 0) return;
            this.$message({
              message: res.msg,
              type: "success",
            });
            this.$parent.getScheduleList();
            this.$emit("closeAddDialog");
          })
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.rc-dialog {
  overflow: hidden;
  /deep/ .el-dialog__body {
    padding-bottom: 40px;
    .form-select {
      width: 80%;
    }
  }

  /deep/ .el-select-dropdown{
    position: absolute !important;
    top: 32px !important;
    left: 0 !important;
  }
  /deep/ .el-picker-panel{
    position: absolute !important;
    top: 32px !important;
    left: 0 !important;
  }
  /deep/ .el-time-panel{
    position: absolute !important;
    top: 32px !important;
    left: 0 !important;
  }

  // /deep/ .time-date-picker {
  //   position: absolute !important;
  // }
}
</style>